import React from 'react';
import './SuccessRoundIcon.less';
import { SuccessIcon } from 'app/components/icons';

export default function SuccessRoundIcon() {
  return (
    <span className="success-round-icon">
      <SuccessIcon height={42} width={42} />
    </span>
  );
}
